<template>
  <div>
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner
        variant="success"
        label="Spinning"
        style="width: 3rem; height: 3rem"
      ></b-spinner>
    </div>
    <b-card v-if="!loading">
      <b-card-body>
        <validation-observer ref="timesheet" #default="{ invalid }">
          <b-form @submit.prevent="formSubmitted">
            <b-row>
              <b-col md="3">
                <b-form-group label="Service Order*" label-for="mc-order">
                  <validation-provider
                    rules="required"
                    #default="{ errors }"
                    name="Service Order"
                    vid="Service Order"
                  >
                    <b-form-select
                      id="mc-order"
                      v-model="timesheetDetails.parentID"
                      :options="serviceOrders"
                      :disabled="type !== 'add' || dis !== 'add'"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Approver*" label-for="mc-approver">
                  <validation-provider
                    rules="required"
                    #default="{ errors }"
                    name="Approver"
                    vid="Approver"
                  >
                    <b-form-select
                      id="mc-approver"
                      :disabled="type !== 'add'"
                      v-model="timesheetDetails.approverID"
                      :options="userList"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Reference*" label-for="mc-reference">
                  <validation-provider
                    rules="required"
                    #default="{ errors }"
                    name="Reference"
                    vid="Reference"
                  >
                    <b-form-input
                      :disabled="type !== 'add'"
                      id="mc-Reference"
                      type="text"
                      v-model="timesheetDetails.reference"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="3">
                      <b-form-group label="Start Time*" label-for="mc-startTime">
                        <validation-provider rules="required" #default="{ errors }" name="Start Time"
                          vid="start Time">
                          <b-form-timepicker id="mc-startTime" :min="new Date()" v-model="timesheetDetails.startTime"
                          :disabled="type !== 'add'"
                           @change="calculateHoursWorked"
                           locale="en"></b-form-timepicker>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col md="3">
                      <b-form-group label="End Time*" label-for="mc-endTime">
                        <validation-provider rules="required" #default="{ errors }" name="End Time"
                          vid="end Time">
                          <b-form-timepicker id="mc-endTime" :min="new Date()" v-model="timesheetDetails.endTime"
                          :disabled="type !== 'add'"
                           @change="calculateHoursWorked"
                           locale="en"></b-form-timepicker>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

              <b-col md="6">
                <b-form-group label="Hours Worked*" label-for="mc-hours">
                  <validation-provider
                    rules="required|min_value:0.01|max_value:24" readonly
                    #default="{ errors }"
                    name="Hours Worked"
                    vid="Hours Worked"
                  >
                    <b-form-input
                      onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight', 'Period', 'NumpadDecimal'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                      :disabled="type !== 'add'"
                      id="mc-hours"
                      type="text"
                      v-model="timesheetDetails.hoursWorked" readonly
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Date*" label-for="mc-date">
                  <validation-provider
                    rules="required"
                    #default="{ errors }"
                    name="Date"
                    vid="Date"
                  >
                    <b-form-datepicker
                      :disabled="type !== 'add'"
                      id="mc-date"
                      :dropup="false"
                      :max="today"
                      v-model="timesheetDetails.date"
                    ></b-form-datepicker>
                    <!-- <flat-pickr :disabled="type === 'view'" v-model="timesheetDetails.date" class="form-control" :config="dateConfig" /> -->
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label="Description"
                  label-for="mc-taskDescription"
                >
                  <!-- <validation-provider rules="required" #default="{ errors }" name="Description" vid="Description"> -->
                  <b-form-textarea
                    :disabled="type !== 'add'"
                    id="mc-taskDescription"
                    type="text"
                    v-model="timesheetDetails.taskDescription"
                  />
                  <!-- <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider> -->
                </b-form-group>
              </b-col>
              <b-col v-if="type !== 'add'" md="6">
                <b-form-group label="Status" label-for="mc-status">
                  <validation-provider
                    rules="required"
                    #default="{ errors }"
                    name="Status"
                    vid="Status"
                  >
                    <b-form-select
                      id="mc-status"
                      :disabled="
                        type === 'view' ||
                        timesheetDetails.approverID !== userId
                      "
                      v-model="timesheetDetails.status"
                      :options="timesheetStatus"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="type !== 'add' && timesheetDetails.status === 'REJECTED'"
                md="6"
              >
                <b-form-group label="Note" label-for="mc-note">
                  <validation-provider
                    rules="required"
                    #default="{ errors }"
                    name="Note"
                    vid="Note"
                  >
                    <b-form-input
                      id="mc-note"
                      :disabled="
                        type === 'view' ||
                        timesheetDetails.approverID !== userId
                      "
                      v-model="timesheetDetails.note"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="type !== 'view'">
              <b-col cols="12">
                <b-button
                  v-if="userId !== timesheetDetails.approverID"
                  variant="primary"
                  class="mt-2 mr-1"
                  @click="submitTimesheet"
                >
                  Save
                </b-button>
                <b-button
                  v-else
                  variant="primary"
                  class="mt-2 mr-1"
                  @click="submitTimesheet"
                >
                  Update
                </b-button>
                <b-button
                  variant="outline-secondary"
                  type="button"
                  class="mt-2"
                  @click="redirectToListing"
                >
                  Cancel
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormDatepicker,
  BInputGroupAppend,
  BButton,
  BDropdown,
  BDropdownItem,
  BSpinner,
  BCard,
  BCardText,
  BCardBody,
  BFormTimepicker,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import {
  customLoader,
  customError,
  customSwal,
  fnSortingDropdown,
} from "@/libs/customFn";
import "@/libs/customValidation";
import { TimesheetStatus } from "@/libs/defaultList";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BFormSelect,
    BCardText,
    BForm,
    BFormGroup,
    BSpinner,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
    BFormTimepicker,
  },
  data() {
    return {
      id: this.$route.params.id,
      type: this.$route.meta.type,
      dis: "",
      today: new Date().toISOString().split("T")[0],
      timesheetDetails: {
        id: null,
        parentID: null,
        employeeID: null,
        date: null,
        hoursWorked: null,
        taskDescription: null,
        approverID: null,
        approvalDate: null,
        status: null,
        note: null,
        startDate: null,
        endDate: null,
        reference: null,
        moduleReference: null,
        startTime: null,
        endTime: null,
      },
      defaultTimesheet: {
        id: null,
        parentID: null,
        employeeID: null,
        date: null,
        hoursWorked: null,
        taskDescription: null,
        approverID: null,
        approvalDate: null,
        status: null,
        note: null,
        startDate: null,
        endDate: null,
        reference: null,
        moduleReference: null,
      },
      dateConfig: {
        wrap: true,
        maxDate: new Date(),
      },
      serviceOrders: [],
      userList: [],
      userId: null,
      timesheetStatus: TimesheetStatus,
      servicereference: "",
      servicedata: null,
    };
  },
  computed: {
    ...mapGetters("serviceModule", {
      serviceOrderList: "serviceOrderList",
      timesheet: "timesheet",
      loading: "loading",
    }),
    ...mapGetters("userModule", {
      users: "users",
      loading: "loading",
    }),
  },
  methods: {
    ...mapActions("serviceModule", [
      "getServiceOrderListAction",
      "getServiceTimesheetAction",
      "postServiceTimesheetAction",
      "putServiceTimesheetAction",
      "getServiceOrderByIDAction",
    ]),
    ...mapActions("userModule", ["getUserListByRoleAction"]),
    async resetTimesheet() {
      this.timesheetDetails = this.defaultTimesheet;
    },
    async redirectToListing() {
      this.$router.push({ name: "servicetimesheet-list" });
    },

    async fetchservicerequestdetails(id) {
    await this.getServiceOrderByIDAction(id).then((service) => {
      if (service && service.referenceNo) {
        this.servicedata = service
        this.timesheetDetails.parentID = service.serviceOrderId.toString();
        this.servicereference = service.referenceNo;
        this.timesheetDetails.employeeID = this.userId;
      }
    });
    },

    errorStart(data) {
      let msg = null;
     // if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: "'End Time' cannot be before 'Start Time'.",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    errorTime(data) {
      let msg = null;
     // if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: "Please select a start time and end time.",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    
    calculateHoursWorked() {
  if (this.timesheetDetails.startTime && this.timesheetDetails.endTime) {
    // Convert startTime and endTime strings to Date objects
    const start = this.convertToDate(this.timesheetDetails.startTime);
    const end = this.convertToDate(this.timesheetDetails.endTime);

    if(start > end){
      this.errorStart();
    }
    // Calculate the difference in milliseconds
    const diff = end - start;

    // Convert milliseconds to hours (if diff is positive)
    const hours = diff / (1000 * 60 * 60);

    this.timesheetDetails.hoursWorked = hours >= 0 ? hours : 0; // Ensure the value is non-negative
    this.timesheetDetails.hoursWorked = this.timesheetDetails.hoursWorked.toFixed(2);
    console.log("hoursworked", this.timesheetDetails.hoursWorked);
  }
},

// Helper method to convert HH:mm string to Date object (assumes the date part is arbitrary, e.g., "1970-01-01")
convertToDate(time) {
  const [hours, minutes] = time.split(":");
  const date = new Date();
  date.setHours(hours, minutes, 0, 0); // Set hours and minutes, leaving seconds and milliseconds as 0
  return date;
},

    async submitTimesheet() {
      let isValid = await this.$refs.timesheet.validate();
      if (isValid) {
        this.timesheetDetails.moduleReference = 'ServiceOrder';
        await this.fetchservicerequestdetails(this.timesheetDetails.parentID);
        if (this.type === "add") {
          let addLoader = customLoader(
            "Please wait while timesheet is being saved"
          );
          await this.postServiceTimesheetAction(this.timesheetDetails)
            .then((res) => {
              if (res.errors) {
                customError(res);
              } else if (res.success) {
                customSwal(res.message);
                this.$router.push("/servicetimesheet/list");
              } else {
                customError(res);
              }
            })
            .catch((err) => customError(err.response.data));
          addLoader.close();
        } else {
          let updateLoader = customLoader(
            "Please wait while timesheet is being updated"
          );
          await this.putServiceTimesheetAction(this.timesheetDetails)
            .then((res) => {
              console.log(res);
              if (res.errors) {
                customError(res);
              } else if (res.success) {
                customSwal(res.message);
                this.$router.push("/servicetimesheet/list");
              } else {
                customError(res);
              }
            })
            .catch((err) => customError(err.response.data));
          updateLoader.close();
        }
      }
    },
  },
  async mounted() {
    const modulereference = 'ServiceOrder';
    this.dis = this.$route.params.id? "edit" : "add";
    const userData = JSON.parse(localStorage.getItem("userData"));
    this.userId = userData.id;

    if (this.type !== "add") {
      await this.getServiceTimesheetAction({modulereference, id: this.id});
      this.defaultTimesheet = this.timesheet;
      this.timesheetDetails = this.timesheet;
    }

    const serviceid = this.$route.params.id
    // const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[4][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;

    if (serviceid && this.type === 'add'){
      await this.getServiceOrderByIDAction(serviceid).then((service) => {
        if (service && service.referenceNo) {
          this.servicereference = service.referenceNo;
          this.timesheetDetails.parentID = service.serviceOrderId.toString();
          this.timesheetDetails.employeeID = this.userId;
        }
      });
      console.log("🚀 ~ awaitthis.getServiceOrderByIDAction ~ this.timesheetDetails.employeeI:", this.timesheetDetails.employeeID)
    }

    await this.getServiceOrderListAction().then(() => {
      this.serviceOrders = this.serviceOrderList.map((service) => {
        return {
          text: service.referenceNo,
          value: service.serviceOrderId.toString(),
        };
      });
    });

    await this.getUserListByRoleAction("staff").then(() => {
      let users = this.users.filter(
        (z) =>
          this.timesheetDetails.approverID === this.userId ||
          z.id !== this.userId
      );
      users = users.map((user) => {
        return { text: `${user.firstName} ${user.lastName}`, value: user.id };
      });
      this.userList = fnSortingDropdown(users);
    });
  },
  watch: {
    'timesheetDetails.startTime': 'calculateHoursWorked',
    'timesheetDetails.endTime': 'calculateHoursWorked',
  },
};
</script>
